// extracted by mini-css-extract-plugin
module.exports =  {"wrapSliders":"wrapSliders___Ybbol","slide":"slide___P1wXp","videoPlaceholder":"videoPlaceholder___k2X2g","playIcon":"playIcon___Nq0rw"};